<div *ngIf="languaje === 'en'">
    <li class="pill"  [ngClass]="{'active': is_active}" (click)="showContent()">
        <a class="icon-money">Scotia Rewards Fixed Rates</a>
    </li>
    
    <a class="icon-money pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Scotia Rewards Fixed Rates</a>
    <div class="tab-pane active" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
    	<h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}"><strong>SCOTIA REWARDS FIXED RATES</strong></h2>

		<div class="container" [ngClass]="{'show': show_description1}">
			<p><strong>Obs.:&nbsp;</strong></p>
			<p>*Travel marketplace <strong>Fixed Rates</strong> option is only available for <strong>Aero</strong> in the <strong>ECR</strong>.</p>
			<p>*<strong>Pay with Points</strong> is <u>not available</u> for <strong>Aero</strong> in the <strong>ECR.</strong></p>

            <ul class="letter">
            	<li>Travel redemption chart to be used for flight travel only</li>
            	<table>
					<tbody>
					<tr>
					<td>
					<p><strong>Roundtrip Destinations</strong></p>
					</td>
					<td colspan="2">
					<p><strong># Of Scotia Points Required</strong></p>
					</td>
					</tr>
					<tr>
					<td>
					<p></p>
					</td>
					<td>
					<p><strong>Economy</strong></p>
					</td>
					<td>
					<p><strong>Business</strong></p>
					</td>
					</tr>
					<tr>
					<td>
					<p><strong>Within the Caribbean</strong></p>
					</td>
					<td>
					<p>20.000</p>
					</td>
					<td>
					<p>40.000</p>
					</td>
					</tr>
					<tr>
					<td>
					<p><strong>Caribbean to Miami (MIA), Orlando (MCO), Fort Lauderdale (FLL), &amp; New York (JFK &amp; LGA)</strong></p>
					</td>
					<td>
					<p>20.000</p>
					</td>
					<td>
					<p>40.000</p>
					</td>
					</tr>
					<tr>
					<td>
					<p><strong>Caribbean to North American East Coast (excluding destinations listed above)</strong></p>
					</td>
					<td>
					<p>30.000</p>
					</td>
					<td>
					<p>60.000</p>
					</td>
					</tr>
					<tr>
					<td>
					<p><strong>Caribbean to North American West Coast</strong></p>
					</td>
					<td>
					<p>50.000</p>
					</td>
					<td>
					<p>100.000</p>
					</td>
					</tr>
					<tr>
					<td>
					<p><strong>Caribbean to Central America, Colombia, Ecuador, Peru, Venezuela</strong></p>
					</td>
					<td>
					<p>50.000</p>
					</td>
					<td>
					<p>100.000</p>
					</td>
					</tr>
					<tr>
					<td>
					<p><strong>Caribbean to Europe</strong></p>
					</td>
					<td>
					<p>70.000</p>
					</td>
					<td>
					<p>140.000</p>
					</td>
					</tr>
					<tr>
					<td>
					<p><strong>Return airfares within the Continental USA</strong></p>
					</td>
					<td>
					<p>30.000</p>
					</td>
					<td>
					<p>60.000</p>
					</td>
					</tr>
					<tr>
					<td>
					<p><strong>One-way airfares and destinations not listed above</strong></p>
					</td>
					<td colspan="2">
					<p>Variable<br /><br /></p>
					</td>
					</tr>
					</tbody>
				</table>
				<li>Any flights from the originating regions mentioned on the chart above would be priced for redemption as per the points mentioned in the table.</li>
				<li>Any flights from the originating regions mentioned "Variable" will be priced at US$0.015 per point. For example, if a ticket costs US$1.500, you would need 100.000 points to be able to use the variable rate.</li>
				<li>Any flights from or between regions outside of the regions mentioned on the chart will be priced at US$0.015 per point.</li>
				<li>For other travel benefits like hotels, car rentals, cruises and other travel related packages, <strong>Scotia Points</strong> are converted to dollars off the cost of any hotel, tour package or cruise reservations for any destination at a rate of 100 <strong>Scotia Points</strong> to US$1.50.</li>
				<li>Any travel demands with less than 14 days from the date of travel would be priced at US$0.015 per point.</li>
				<li>All flights need to originate from the country of Cardholder domicile.</li>
            </ul>
            <p>Conversion to local currency:</p>
			<p>US$1 = Bahamian dollar 1</p>
			<p>US$1 = Belize dollar $2 BZ</p>
			<p>US$1 = Barbados dollar $2 BDS</p>
			<p>US$1 = Jamaican dollar $140 JMD</p>
			<p>US$1 = Trinidadian dollar $6.60 TT</p>
			<p>US$1 = US$1 for Turks and Caicos</p>
			<ul class="point">
				<li>Conversion rates are subject to change in the Bank's sole and absolute discretion without prior notice to you.</li>
			</ul>
        </div>
    </div>
</div>


<!-- Español -->
<!-- Español -->


<div *ngIf="languaje === 'es'">
    <li class="pill"  [ngClass]="{'active': is_active}" (click)="showContent()">
        <a class="icon-money">Tarifas Fijas de Scotia Rewards</a>
    </li>
    
    <a class="icon-money pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Tarifas Fijas de Scotia Rewards</a>
    <div class="tab-pane active" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
    	<h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}"><strong>TARIFAS FIJAS DE SCOTIA REWARDS</strong></h2>

        <div class="container" [ngClass]="{'show': show_description1}">
			<p><strong>Obs.:</strong></p>
			<p>*La opci&oacute;n de <strong>Tarifas Fijas</strong> del Marketplace solo est&aacute; disponible para <strong>Aero</strong> en el <strong>ECR</strong>.</p>
			<p>*<strong>Pagar con Puntos </strong> <u>no est&aacute; disponible</u> para <strong>Aero</strong> en el <strong>ECR</strong>.</p>
        	<ul class="letter">
        		<li>
        			Tabla de canje de viajes que se utilizará solo para viajes aéreos
        			<table>
						<tbody>
						<tr>
						<td>
						<p><strong>Destinos de Ida y Vuelta</strong></p>
						</td>
						<td colspan="2">
						<p><strong># de Scotia Puntos Requeridos</strong></p>
						</td>
						</tr>
						<tr>
						<td>
						<p></p>
						</td>
						<td>
						<p><strong>Econ&oacute;mica</strong></p>
						</td>
						<td>
						<p><strong>Ejecutiva</strong></p>
						</td>
						</tr>
						<tr>
						<td>
						<p><strong>Dentro del Caribe</strong></p>
						</td>
						<td>
						<p>20,000</p>
						</td>
						<td>
						<p>40,000</p>
						</td>
						</tr>
						<tr>
						<td>
						<p><strong>Del Caribe a Miami (MIA), Orlando (MCO), Fort Lauderdale (FLL), &amp; New York (JFK &amp; LGA)</strong></p>
						</td>
						<td>
						<p>20,000</p>
						</td>
						<td>
						<p>40,000</p>
						</td>
						</tr>
						<tr>
						<td>
						<p><strong>Del Caribe hasta la Costa este de Am&eacute;rica del Norte (excepto los destinos mencionados anteriormente)</strong></p>
						</td>
						<td>
						<p>30,000</p>
						</td>
						<td>
						<p>60,000</p>
						</td>
						</tr>
						<tr>
						<td>
						<p><strong>Del Caribe a la costa oeste de Am&eacute;rica del Norte</strong></p>
						</td>
						<td>
						<p>50,000</p>
						</td>
						<td>
						<p>100,000</p>
						</td>
						</tr>
						<tr>
						<td>
						<p><strong>Del Caribe hasta la Am&eacute;rica Central, Colombia, Ecuador, Per&uacute;, Venezuela</strong></p>
						</td>
						<td>
						<p>50,000</p>
						</td>
						<td>
						<p>100,000</p>
						</td>
						</tr>
						<tr>
						<td>
						<p><strong>Del Caribe hasta Europa</strong></p>
						</td>
						<td>
						<p>70,000</p>
						</td>
						<td>
						<p>140,000</p>
						</td>
						</tr>
						<tr>
						<td>
						<p><strong>Tarifas a&eacute;reas de retorno dentro de EE.UU. Continental</strong></p>
						</td>
						<td>
						<p>30,000</p>
						</td>
						<td>
						<p>60,000</p>
						</td>
						</tr>
						<tr>
						<td>
						<p><strong>Tarifas a&eacute;reas de ida y destinos no enumerados anteriormente</strong></p>
						</td>
						<td colspan="2">
						<p>Variable<br /><br /></p>
						</td>
						</tr>
						</tbody>
					</table>
        		</li>
        		<li>Cualquier vuelo desde las regiones de origen mencionadas en la tabla anterior tendr&aacute; un precio para canje seg&uacute;n los puntos mencionados en la tabla.</li>
				<li>Cualquier vuelo desde las regiones de origen mencionadas como "Variable" tendr&aacute; un precio de US$0.015 por punto. Por ejemplo, si un boleto cuesta US$1.500, necesitar&iacute;a 100.000 puntos para poder utilizar la tarifa variable.</li>
				<li>Cualquier vuelo desde o entre regiones fuera de las regiones mencionadas en la tabla tendr&aacute; un precio de US$0.015 por punto.</li>
				<li>Para otros beneficios de viaje como hoteles, alquiler de autom&oacute;viles, cruceros y otros paquetes relacionados con viajes, los Scotia Points se convierten en d&oacute;lares de descuento en el costo de cualquier hotel, paquete tur&iacute;stico o reserva de cruceros para cualquier destino a una tarifa de 100 Scotia Points a US$1.50.</li>
				<li>Cualquier demanda de viaje con menos de 14 d&iacute;as a partir de la fecha del viaje tendr&iacute;a un precio de US$0.015 por punto.</li>
				<li>Todos los vuelos deben tener su origen en el pa&iacute;s del domicilio del Titular de la Tarjeta.</li>
        	</ul>
        	<p>Conversi&oacute;n a moneda local:</p>
			<p>US$1 = D&oacute;lar de las Bahamas 1</p>
			<p>US$1 = D&oacute;lar de Belice $2 BZ</p>
			<p>US$1 = D&oacute;lar de Barbados $2 BDS</p>
			<p>US$1 = D&oacute;lar de Jamaica $140 JMD</p>
			<p>US$1 = D&oacute;lar de Trinidad $6.60 TT</p>
			<p>US$1 = US$1 para Turcas and Caicos</p>
			<ul class="point">
				<li>Las tasas de conversi&oacute;n est&aacute;n sujetas a cambios a exclusivo y absoluto criterio del Banco sin previo aviso.</li>
			</ul>
        </div>
    </div>
</div>
